import Vue from "vue";
import accounting from "accounting";
import moment from 'moment';
import 'moment-timezone';


/**
 * Formats a phone number.
 * Example: 123-456-7890 => (123) 456-7890
 *
 * @param {String} phone
 * @return {void}
 */
Vue.filter('phone', function (phone) {
    return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});

/**
 * Formats a money amount.
 *
 * @param {String} number
 * @return {String}
 */
Vue.filter('money', function (number, currency = '$', decimals = 2) {
    return accounting.formatMoney(number, currency, decimals);
});

/**
 * Formats a percentage.
 *
 * @param {String} number
 * @return {String}
 */
Vue.filter('percentage', function (number, decimals = 2) {
    if (typeof number === 'undefined') {
        return '';
    }

    number = parseFloat(number);

    return number.toFixed(decimals) + '%';
});

/**
 * Formats a date time string to date time.
 *
 * @param {String} date
 * @return {String}
 */
Vue.filter('formatDateTime', function (date) {
    return moment(date, 'Y-MM-DD HH:mm:ss').format('MM/DD/Y HH:mm');
});

/**
 * Formats a date time string to date time.
 *
 * @param {String} date
 * @return {String}
 */
Vue.filter('formatDateTimeWithTz', function ({time, timezone}) {
    return moment(time).tz(timezone).format('MM/DD/Y HH:mm');
});
